import { render, staticRenderFns } from "./DeclaracaoConcessionaria.vue?vue&type=template&id=0c5a336f&scoped=true&"
import script from "./DeclaracaoConcessionaria.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoConcessionaria.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoConcessionaria.vue?vue&type=style&index=0&id=0c5a336f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a336f",
  null
  
)

export default component.exports